import { BeRow, BeTrackerClock } from "@beos-css/react/index.ts";

export function TrackerClockDemo() {
	return (
		<section id="demo-clock">
			<h2>Tracker clock (BeTrackerClock)</h2>
			<p>The Deskbar's digital clock (12-hour "h:mm AM/PM"); it ticks live, once a minute.</p>
			<BeRow wrap gap="row">
				<BeTrackerClock />
			</BeRow>
		</section>
	);
}
